import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import tw from 'twin.macro';
import IncognitoIcon from '@assets/icons/IncognitoIcon';
import NetworkIcon from '@assets/icons/NetworkIcon';
import ServerIcon from '@assets/icons/ServerIcon';

const ApiConnectionProblem = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const [time, setTime] = useState(30);

  // eslint-disable-next-line consistent-return -- FIXME
  useEffect(() => {
    if (time > 0) {
      const interval = setInterval(() => {
        setTime(time - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
    // eslint-disable-next-line no-use-before-define -- FIXME
    handleClickRefresh();

    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [time]);

  const handleClickRefresh = () => {
    router.reload();
  };

  return (
    <div
      tw="min-h-screen flex justify-center items-center bg-gray-0"
      data-cy="ApiConnectionProblem_div"
    >
      <div tw="max-w-3xl w-full rounded-lg p-5 shadow-lg bg-white">
        <div css={[tw`mx-auto`, { maxWidth: '650px' }]}>
          <h1 tw="mb-8 font-bold" css={{ color: '#87683b' }}>
            {t(
              '$*components.connectionProblem.title',
              'Ups, wystąpił problem z załadowaniem strony.'
            )}
            <span tw="text-lg font-normal" css={{ color: '#A79175' }}>
              {' '}
              Oops, there was a problem loading the page.
            </span>
          </h1>

          <div tw="flex pb-7">
            <div tw="w-6 mr-4" css={{ color: '#87683b' }}>
              <NetworkIcon />
            </div>
            <div>
              <p tw="mb-0">
                {t(
                  '$*components.connectionProblem.bullet1',
                  'Sprawdź, czy Twoje połączenie z internetem jest stabilne.'
                )}
              </p>
              <p tw="text-base text-gray-2">
                Check that your internet connection is stable.
              </p>
            </div>
          </div>
          <div tw="flex pb-7">
            <div tw="w-6 mr-4" css={{ color: '#87683b' }}>
              <IncognitoIcon />
            </div>
            <div>
              <p tw="mb-0">
                {t(
                  '$*components.connectionProblem.bullet2',
                  'Jeśli tak, spróbuj otworzyć stronę w trybie incognito.'
                )}
              </p>
              <p tw="text-base text-gray-2">
                If so, try opening the site in incognito mode.
              </p>
            </div>
          </div>
          <div tw="flex pb-7">
            <div tw="w-6 mr-4" css={{ color: '#87683b' }}>
              <ServerIcon />
            </div>
            <div>
              <p tw="mb-0">
                {t(
                  '$*components.connectionProblem.bullet3',
                  'Jeżeli nadal pojawia się problem, prawdopodobnie nasz serwer ma chwilową przerwę.'
                )}
              </p>
              <p tw="text-base text-gray-2">
                If there is still a problem, it is likely that our server is
                experiencing a temporary interruption.
              </p>
            </div>
          </div>
          <div
            css={[
              tw`text-sm text-center border-t pt-7 mb-7`,
              { color: '#636c79', borderColor: '#87683b' },
            ]}
          >
            <p tw="mb-0">
              {t('$*components.connectionProblem.refreshTimer', {
                defaultValue:
                  'Strona zostanie odświeżona automatycznie za {{sec}}s',
                sec: time,
              })}
            </p>
            <p tw="text-gray-2">
              {`The page will be refreshed automatically after ${time}s`}
            </p>
          </div>
          <button
            onClick={handleClickRefresh}
            css={css`
              background: #87683b;
              border-color: #87683b;

              &:hover {
                background: #7a5e36;
                border-color: #7a5e36;
              }

              ${tw`w-full max-w-xs mx-auto px-6 py-3 text-sm font-bold uppercase text-center rounded-md align-middle duration-300 border border-transparent cursor-pointer select-none focus-visible:(ring-2 outline-none ring-offset-2) hover:(transition-colors duration-300)`}
              ${tw`table tracking-wide text-white`}
            `}
          >
            Odśwież teraz <span tw="text-xs opacity-50">/ Refresh now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiConnectionProblem;
